import { Navigate, useLocation } from "react-router-dom"

/**
 * `/booking` opens the select step and keeps the query: the dates, location or deep-linked screen
 * a link opened booking with. A bare `<Navigate to="select">` drops it, so a link that opened
 * booking on given dates (Book again, MPE-1411) landed on the default dates, which then disagreed
 * with the cart and raised the date-change dialog nobody asked for. LegacyBookingRedirect keeps the
 * query for the same reason.
 */
export function BookingIndexRedirect() {
  const { search, hash } = useLocation()
  return <Navigate to={{ pathname: "select", search, hash }} replace />
}
